export default __webpack_public_path__ + "logo_cemca.b5776556.png";